import { isOnexVariant } from "@otto-ec/global-resources/onex";

const onexGroups = ["E3823B", "E3823C", "E3823D", "E3823E"] as const;
const activeOnexVariant = onexGroups.find((v) => isOnexVariant("E3823", v));

export const showComparativeStrikethrough = (isUvp: boolean) =>
  activeOnexVariant === undefined ||
  !isUvp ||
  activeOnexVariant === "E3823C" ||
  activeOnexVariant === "E3823E";
export const showCurrentSaleColor = (isUvp: boolean) =>
  activeOnexVariant === undefined ||
  !isUvp ||
  activeOnexVariant === "E3823D" ||
  activeOnexVariant === "E3823E";
export const showDiscountTag = (isUvp: boolean) =>
  activeOnexVariant === undefined || !isUvp;
